<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';

    import { personalizeText, getColor } from '$lib/helper';

    import TextView from './Text.View.svelte';

    import type { TextContent } from '$lib/types/Components/Text/TextContent';
    import type { Language } from '$lib/types/Language';
    import type { Theme } from '$lib/types/Theme';
    import type { TrackingProperty } from '$lib/types/TrackingProperty';

    export let content: TextContent;
    export let theme: Theme;
    export let transitionDelay: number;
    export let transitionEffect = 'default';
    export let campaignId: string;
    export let trackingProperties: TrackingProperty[];
    export let language: Language = 'en';
    export let layout = DEFAULT_LAYOUT;

    let personalizedText = personalizeText(
        content.wysiwyg,
        trackingProperties,
        campaignId,
        language,
    );
</script>

<TextView
    raw={personalizedText}
    align={content.align}
    color={getColor(content.color, theme.fontColor)}
    box={content.box}
    linkColor={theme.buttonBackgroundColor}
    {transitionDelay}
    {transitionEffect}
    {layout}
/>
